export default "__VITE_PUBLIC_ASSET__4ced80a9__"